<div class="card">
  <div class="card-body" [ngClass]="{ 'expired-card': expired }">
    <div>
      <i class="pi pi-clock"></i>
    </div>
    <div>
      @if (timeLeft > 0) {
        <span>{{ formattedTime }} </span>
      } @else {
        <p class="p m-0 text-warning">
          Tempo esgotado! Os ingressos foram removidos do carrinho e estão disponíveis novamente para venda.
        </p>
      }
    </div>
    <div>
      @if (timeLeft > 0) {
        <p class="p m-0 text-secondary">Os ingressos serão liberados automaticamente quando o tempo acabar.</p>
      }
    </div>
  </div>
</div>
